import React from "react";
import themeLarge from "../ThemeLarge";

class ProjectSortYearView extends React.Component {
  render() {
    const { label, active } = this.props;
    const baseStyle = {
      fontFamily: "Kumbh Sans",
      color: themeLarge.colors.bg,
      backgroundColor: themeLarge.colors.primary,
      paddingTop: "10px",
      paddingBottom: "10px",
      fontSize: themeLarge.fontSize.h4,
      borderWidth: "0px",
      borderStyle: "dashed",
      borderColor: themeLarge.colors.primary,
      borderRadius: "15px",
      boxShadow: themeLarge.shadows.standard,
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
    };

    const activeStyle = {
      color: themeLarge.colors.primary,
      backgroundColor: themeLarge.colors.bg,
      transform: "scale(1.03)",
      boxShadow: themeLarge.shadows.large,
    };

    const finalStyle = active ? { ...baseStyle, ...activeStyle } : baseStyle;

    return (
      <>
        <div className={`d-flex justify-content-center`} style={finalStyle}>
          {label}
        </div>
      </>
    );
  }
}

export default ProjectSortYearView;
